<template>
	<div>
		<h5>Inspection</h5>
	</div>
</template>

<script>
	export default {
		name: "Inspection",
	};
</script>

<style scoped></style>
